import { defineComponent as _defineComponent } from 'vue'

import type {  IMatch } from "~src/interfaces";


const __default__ = {};

interface IProps {
  match: IMatch;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'TabStatsHtFt',
  props: {
    match: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return null
}
}

})